import { render, staticRenderFns } from "./drawBill.vue?vue&type=template&id=1b981dae&scoped=true&"
import script from "./drawBill.vue?vue&type=script&lang=js&"
export * from "./drawBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b981dae",
  null
  
)

export default component.exports